<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.h6.basic800--text {{ $t('update_customer_address') }}
      v-divider.basic300
      v-card-text.pa-0
        v-form(ref="form")
          v-card.pa-4
            address-inputs-id(v-if="isIndoAddress" :parentAddress.sync="address")
            address-inputs(v-else :parentAddress.sync="address" :autofillPostcode="false")
      v-card-actions
        v-spacer
        v-btn.button-AA-medium(color='grey', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.button-AA-medium.mr-2.white--text(color='info500' depressed height=32 :loading="isLoading" @click='clickSave')
          | {{ $t('update') }}

</template>

<script>
import { mapActions } from 'vuex'
import AddressInputs from '@/components/AddressInputs.vue'
import AddressInputsId from '@/components/AddressInputsId.vue'

export default {
  name: 'AddCustomerAddress',
  props: ['open', 'parentLead'],
  components: { AddressInputs, AddressInputsId },
  data: () => ({
    isLoading: false,
    address: {}
  }),
  computed: {
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('update:parentLead', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isIndoAddress () {
      if (this.parentLead.shipping_address) {
        if (this.parentLead.shipping_address.area) {
          return true
        }
      } else if (this.$currency.code === 'IDR') {
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.parentLead.shipping_address) {
      this.address = { ...this.parentLead.shipping_address }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const params = {
        shipping_address: this.address
      }
      this.axios.patch(`/leads/${this.lead.pid}/`, params)
        .then(resp => {
          this.showMessage(['success', this.$t('success_message.address_updated')])
          this.lead = resp.data
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "update_customer_address": "Update customer address"
  },
  "id": {
    "update_customer_address": "Perbarui Alamat Pelanggan"
  }
}
</i18n>
